import axios from 'axios';

export default axios.create({
  //baseURL: "http://localhost:4000",
  baseURL: "https://blg-backend.herokuapp.com/",
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*"
  }
})